import { GET_ONE, CREATE } from 'react-admin';

import * as constants from '../../constants/index';
import {
    GET_FLIGHT_REQUEST,
    GET_FLIGHT_REQUEST_CLEAR,
    APPROVE_FLIGHT_REQUEST,
    APPROVE_FLIGHT_REQUEST_CLEAR,
    SAVE_FLIGHT_REQUEST,
    SAVE_FLIGHT_REQUEST_CLEAR,
    REJECT_FLIGHT_REQUEST,
    REJECT_FLIGHT_REQUEST_CLEAR,
    OFFER_FLIGHT_REQUEST,
    OFFER_FLIGHT_REQUEST_CLEAR,
    SUBMIT_OFFER_FLIGHT_REQUEST,
    SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR,
} from './types';

export const getFlightRequest = (flightRequestId: string) => ({
    type: GET_FLIGHT_REQUEST,
    payload: { id: flightRequestId },
    meta: {
        fetch: GET_ONE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.GET_FLIGHT_REQUEST}`,
    },
});

export const approveFlightRequest = (flightRequest: any) => ({
    type: APPROVE_FLIGHT_REQUEST,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.APPROVE_FLIGHT_REQUEST}`,
    },
});

export const saveFlightRequest = (flightRequest: any) => ({
    type: SAVE_FLIGHT_REQUEST,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.SAVE_FLIGHT_REQUEST}`,
    },
});

export const rejectFlightRequest = (flightRequest: any) => ({
    type: REJECT_FLIGHT_REQUEST,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REJECT_FLIGHT_REQUEST}`,
    },
});

export const offerFlightRequest = (flightRequest: any) => ({
    type: OFFER_FLIGHT_REQUEST,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REVIEW_OFFER}`,
    },
});

export const submitOfferFlightRequest = (flightRequest: any) => ({
    type: SUBMIT_OFFER_FLIGHT_REQUEST,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.SUBMIT_OFFER}`,
    },
});

export const clearFlightRequest = () => ({
    type: GET_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearApproveFlightRequest = () => ({
    type: APPROVE_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearSaveFlightRequest = () => ({
    type: SAVE_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearRejectFlightRequest = () => ({
    type: REJECT_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearOfferFlightRequest = () => ({
    type: OFFER_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearSubmitOfferFlightRequest = () => ({
    type: SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR,
    payload: {},
});
